import { PlanActionType } from '../../context/plan/actions';
import { usePlanContext } from '../../context/plan/context';
import { Stop } from '../../domain/stop/Stop';

type UseSetActivePlanFocusedStopResponse = {
  setFocusedStop: (focusedStop?: Stop) => void;
  focusedStop?: Stop;
};

// Hooks act as 'Adapter' layer.
export const useSetActivePlanFocusedStop = (): UseSetActivePlanFocusedStopResponse => {
  const { planState, planDispatch } = usePlanContext();

  const setFocusedStop = (focusedStop?: Stop) => {
    if (focusedStop?.id !== planState.activePlan.focusedStop?.id) {
      planDispatch({
        type: PlanActionType.SET_ACTIVE_PLAN_FOCUSED_STOP,
        payload: {
          focusedStop: focusedStop,
        },
      });
    }
  };

  return {
    setFocusedStop,
    focusedStop: planState.activePlan.focusedStop,
  };
};
